import type { ReactNode } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import FloatingActions from "@/components/feature/FloatingActions";

type SiteLayoutProps = {
  children: ReactNode;
};

export default function SiteLayout({ children }: SiteLayoutProps) {
  return (
    <div className="min-h-screen bg-background-50 pb-16 md:pb-0">
      <SiteHeader />
      <main>{children}</main>
      <SiteFooter />
      <FloatingActions />
    </div>
  );
}